import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { NewJournalScreen } from "../screens/JournalsScreen";

export const Route = createFileRoute("/prototype/c/$companyId/journals/new")({
  component: NewJournal,
});

function NewJournal() {
  const { companyId } = Route.useParams();
  return <NewJournalScreen companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY} />;
}
